import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";

import Login from "./components/login/Login";
import Dashboard from "./pages/dashboard/Dashboard";
import PrivateRoute from "./routes/PrivateRoute";
import Layout from "./components/layout/Layout";
import Settings from "./pages/settings/Settings";
import InactivityTimeout from "./components/inactivityTimeout/InactivityTimeout";
import UserList from "./pages/users/Users";
import Bookings from "./pages/bookings/Bookings";
import ContentManagement from "./pages/contentManagement/ContentManagement";
import Ticket from "./pages/bookings/ticket/Ticket";
import NegotiatePrice from "./pages/negotiatePrice/NegotiatePrice";
import Commission from "./pages/commisions/Commision";
import Luggage from "./pages/luggage/Luggage";
import RbdManagement from "./pages/rbdManagement/RbdManagement";
import Coupon from "./pages/coupons/Coupon";
import Banners from "./pages/banners/Banners";
import TerminalBookingImport from "./pages/terminalBookings/TerminalBooking";
import TransportScheduler from "./pages/transport/TransportScheduler";
import AbandonedCarts from "./pages/abandonedCarts/AbandonedCarts";
import SearchAnalytics from "./pages/searchAnalytics/SearchAnalytics";

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <InactivityTimeout>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/users"
              element={
                <PrivateRoute>
                  <Layout>
                    <UserList />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/bookings"
              element={
                <PrivateRoute>
                  <Layout>
                    <Bookings />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/terminal-bookings"
              element={
                <PrivateRoute>
                  <Layout>
                    <TerminalBookingImport />
                  </Layout>
                </PrivateRoute>
              }
            />

            {/* --- NEW ROUTE FOR TRANSPORT SCHEDULER --- */}
            <Route
              path="/transport-scheduler"
              element={
                <PrivateRoute>
                  <Layout>
                    <TransportScheduler />
                  </Layout>
                </PrivateRoute>
              }
            />
            {/* ----------------------------------------- */}

            <Route
              path="/bookings/ticket/:id"
              element={
                <PrivateRoute>
                  <Layout>
                    <Ticket />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <PrivateRoute>
                  <Layout>
                    <Settings />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/commissions"
              element={
                <PrivateRoute>
                  <Layout>
                    <Commission />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/luggage"
              element={
                <PrivateRoute>
                  <Layout>
                    <Luggage />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/rbdManagement"
              element={
                <PrivateRoute>
                  <Layout>
                    <RbdManagement />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/negotiatePrice"
              element={
                <PrivateRoute>
                  <Layout>
                    <NegotiatePrice />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/contentManagement"
              element={
                <PrivateRoute>
                  <Layout>
                    <ContentManagement />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/coupons"
              element={
                <PrivateRoute>
                  <Layout>
                    <Coupon />
                  </Layout>
                </PrivateRoute>
              }
            />
            <Route
              path="/banners"
              element={
                <PrivateRoute>
                  <Layout>
                    <Banners />
                  </Layout>
                </PrivateRoute>
              }
            />
          
            <Route
              path="/abandoned-carts"
              element={
                <PrivateRoute>
                  <Layout>
                    <AbandonedCarts />
                  </Layout>
                </PrivateRoute>
              }
            />

          
            <Route
              path="/search-analytics"
              element={
                <PrivateRoute>
                  <Layout>
                    <SearchAnalytics />
                  </Layout>
                </PrivateRoute>
              }
            />

          </Routes>
        </InactivityTimeout>
      </Router>
    </AuthProvider>
  );
};

export default App;
